import React from "react";
import { Link } from "react-router-dom";
import { getChantierId } from "../utils/getId";

const ChantierCard = ({ chantier, onDelete, onClose, onCardClick, onCancel }) => {
  const cid = chantier?._id || chantier?.id || getChantierId(chantier);

  return (
    <div
      className="chantier-card"
      style={{ cursor: "pointer" }}
      onClick={() => onCardClick && onCardClick(chantier)}
    >
      <div className="chantier-header">
        <h3 className="chantier-title">{chantier.nomChantier}</h3>
        <span
          className={
            chantier.etat === "fermé"
              ? "chantier-etat closed"
              : chantier.etat === "annulé"
              ? "chantier-etat canceled"
              : "chantier-etat active"
          }
        >
          {chantier.etat}
        </span>
      </div>

      <div className="chantier-details">
        <div className="detail-item">
          <span className="detail-label">N° Bon de commande : </span>
          <span className="detail-value">{chantier.numAttachement}</span>
        </div>
        <div className="detail-item">
          <span className="detail-label">Numéro de commande:</span>
          <span className="detail-value">
            {chantier.numeroCommande || chantier.numero_commande || "-"}
          </span>
        </div>
        <div className="detail-item">
          <span className="detail-label">Client:</span>
          <span className="detail-value">{chantier.client}</span>
        </div>
        <div className="detail-item">
          <span className="detail-label">Plombier:</span>
          <span className="detail-value">{chantier.plombier || "-"}</span>
        </div>
        <div className="detail-item">
          <span className="detail-label">Chiffre d'affaire:</span>
          <span className="detail-value">
            {chantier.prixPrestation
              ? chantier.prixPrestation.toLocaleString("fr-FR", {
                  style: "currency",
                  currency: "EUR",
                })
              : "-"}
          </span>
        </div>
        <div className="detail-item">
          <span className="detail-label">Date début:</span>
          <span className="detail-value">
            {chantier.dateDebut
              ? new Date(chantier.dateDebut).toLocaleDateString("fr-FR")
              : "-"}
            {chantier.heureDebut ? ` à ${chantier.heureDebut}` : ""}
          </span>
        </div>
        <div className="detail-item">
          <span className="detail-label">Date fin:</span>
          <span className="detail-value">
            {chantier.dateFin
              ? new Date(chantier.dateFin).toLocaleDateString("fr-FR")
              : "-"}
            {chantier.heureFin ? ` à ${chantier.heureFin}` : ""}
          </span>
        </div>
      </div>

      <div className="chantier-card-actions" onClick={(e) => e.stopPropagation()}>
        <Link to={`/edit/${cid}`} className="btn btn-edit btn-sm">
          ✏️ Modifier
        </Link>
        <Link to={`/charges/${cid}`} className="btn btn-charges btn-sm">
          💰 Charges
        </Link>
        <button
          className="btn btn-delete btn-sm"
          onClick={() => onDelete && cid && onDelete(cid)}
        >
          🗑️ Supprimer
        </button>
        {chantier?.etat === "en cours" && (
          <button
            className="btn btn-sm btn-warning"
            onClick={() => onCancel && cid && onCancel(cid)}
          >
            Annuler le chantier
          </button>
        )}
        {chantier?.etat !== "fermé" && (
          <button
            className="btn btn-close btn-sm"
            onClick={() => onClose && cid && onClose(cid)}
          >
            Fermer le chantier
          </button>
        )}
      </div>
    </div>
  );
};

export default ChantierCard;
